import { render, staticRenderFns } from "./header.vue?vue&type=template&id=01269606&scoped=true&"
import script from "./header.js?vue&type=script&lang=js&"
export * from "./header.js?vue&type=script&lang=js&"
import style0 from "./header.scss?vue&type=style&index=0&id=01269606&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01269606",
  null
  
)

export default component.exports